module.exports = __webpack_public_path__ + "static/media/tmc-footer-logo.5faef7e5.png";